import React from 'react';
import { makeStyles } from '@mui/styles';
import { Box, FilledInput, FormControl, FormHelperText, InputLabel, Select } from '@mui/material';
import { InputElementEvent } from '../model';

export interface BaseSelectInputProps {
  value?: string;
  label: string;
  onChange?: (element: React.ChangeEvent) => void;
  valueChanged?: (value: string) => void;
  styleOverrides?: string;
  errorMessage?: string;
  isFilled?: boolean;
  type?: string;
  textColor?: string;
  disabled?: boolean;
}

export const useSelectInputStyles = makeStyles((_theme) => ({
  textField: {
    height: '30px',
    width: '100%',
    margin: '0 0 4px',
  },
  helperText: {
    fontSize: '12px',
  },
}));

export const createSelectInputChangeHandler = (
  onChange?: (element: React.ChangeEvent) => void,
  valueChanged?: (value: string) => void,
) => {
  return (event: InputElementEvent): void => {
    if (onChange) {
      onChange(event);
    }
    if (valueChanged) {
      valueChanged(event.target.value);
    }
  };
};

interface SelectInputWrapperProps {
  label: string;
  value: string;
  errorMessage?: string;
  styleOverrides?: string;
  disabled?: boolean;
  classes: ReturnType<typeof useSelectInputStyles>;
  onChange: (event: InputElementEvent) => void;
  children: React.ReactNode;
}

export const SelectInputWrapper: React.FC<SelectInputWrapperProps> = ({
  label,
  value,
  errorMessage,
  styleOverrides,
  disabled = false,
  classes,
  onChange,
  children,
}) => {
  return (
    <Box style={{ marginBottom: 25 }}>
      <FormControl
        disabled={disabled}
        variant="filled"
        error={errorMessage?.length > 0}
        className={`${styleOverrides} ${classes.textField}`}
      >
        <InputLabel htmlFor="{label}" shrink>
          {label}
        </InputLabel>
        <Select value={value} input={<FilledInput onChange={onChange} />}>
          {children}
        </Select>
        {errorMessage && <FormHelperText className={classes.helperText}>{`${label} ${errorMessage}`}</FormHelperText>}
      </FormControl>
    </Box>
  );
};
